// The Settings "Admin override" switch, the shared admin mode
// (@jkast90/kast-common/auth) kept on the device under "adminOverride.v2". Like
// the rest of the family's it starts ON: only a stored "false" keeps it off,
// so an admin sees the Admin link and the edit controls until they switch it
// off. It only decides what to show: useAdmin ANDs it with the server's
// /admin/verify, and the API checks the group on every request.

import { createAdminMode } from "@jkast90/kast-common/auth";

/**
 * Where an admin's choice about admin override is remembered. ".v2" since
 * 2026-10-30: until then a not-admin answer from /admin/verify stored "false"
 * here, which hid the Admin link from every later admin on the device; a new
 * key starts every device fresh (on) instead of trusting those values. The
 * old "adminOverride" key is left alone and unread.
 */
export const ADMIN_OVERRIDE_KEY = "adminOverride.v2";

/** The family-wide group and kindly's own; the API's ADMIN_GROUPS. */
export const ADMIN_GROUPS = ["admin", "kindly-admin"] as const;

export const adminModeOptions = {
  admin: ADMIN_GROUPS,
  storageKey: ADMIN_OVERRIDE_KEY,
} as const;

export const adminMode = createAdminMode(adminModeOptions);
